import React, {ReactNode} from "react"
import {Button} from "scholastic-client-components/src/ui/Button/Button"
import styles from "./SSOErrorTemplate.module.scss"
import {useTranslation} from "react-i18next"
import {AuthHeader} from "../../Auth/AuthHeader/AuthHeader"

interface SSOErrorTemplateProps {
    headerTitle: string
    message: ReactNode
    handleRedirectToLogin: () => void
}

export const SSOErrorTemplate: React.FC<SSOErrorTemplateProps> = ({
    headerTitle,
    message,
    handleRedirectToLogin,
}) => {
    const {t} = useTranslation(["auth_portal"])

    return (
        <div className={styles.disabledWrapper}>
            <AuthHeader text={headerTitle} onLogoClick={handleRedirectToLogin} />
            <div className={styles.disabledMessage}>{message}</div>
            <Button onClick={handleRedirectToLogin} primary style={{width: "14rem"}}>
                {t("auth_portal:auth_page.back_to_login_button")}
            </Button>
        </div>
    )
}
